module.exports = __webpack_public_path__ + "static/img/SC7.279cbb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC7.jpg
// module id = 9fjW
// module chunks = 0